import { render } from "./StudentClassManage.vue?vue&type=template&id=cbbc2de2&scoped=true"
import script from "./StudentClassManage.vue?vue&type=script&lang=js"
export * from "./StudentClassManage.vue?vue&type=script&lang=js"

import "./StudentClassManage.vue?vue&type=style&index=0&id=cbbc2de2&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbbc2de2"]])

export default __exports__